module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hres6oe-checkin",
    attrs: {
      "name": "hres6oe-checkin"
    }
  }, [_c('div', {
    staticClass: "data-loading infinite-loading-container animated fadeIn",
    class: [_vm.flgLoading ? '-show' : '-hide']
  }, [_c('i', {
    staticClass: "loading-wave-dots"
  })]), _vm._v(" "), _c('work-place', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.placeDisp),
      expression: "placeDisp"
    }],
    attrs: {
      "label": _vm.labels[_vm.app.nowLang],
      "workPlace": _vm.workPlaceData,
      "toggle": _vm.toggle,
      "startFlgLoading": _vm.startFlgLoading,
      "stopFlgLoading": _vm.stopFlgLoading,
      "lastCheckIn": _vm.lastCheckIn,
      "center": _vm.center,
      "app": _vm.app,
      "setPathImage": _vm.setPathImage,
      "receivedCheckInHistory": _vm.receivedCheckInHistory,
      "receivedCheckInPlace": _vm.receivedCheckInPlace,
      "receivedDataInRaius": _vm.receivedDataInRaius,
      "dataInRadius": _vm.dataInRadius,
      "getMeLocation": _vm.getMeLocation,
      "stopInterval": _vm.stopInterval,
      "scrollTop": _vm.scrollTop,
      "saveCheckInLog": _vm.saveCheckInLog,
      "clearFilterLocation": _vm.clearFilterLocation,
      "selectedCompanyCheckin": _vm.selectedCompanyCheckin,
      "setSelectedCompanyCheckin": _vm.setSelectedCompanyCheckin
    }
  }), _vm._v(" "), _c('check-in-out', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.detailDisp),
      expression: "detailDisp"
    }],
    attrs: {
      "label": _vm.labels[_vm.app.nowLang],
      "toggle": _vm.toggle,
      "dropdowns": _vm.dropdowns.codreason[_vm.app.nowLang],
      "lastCheckIn": _vm.lastCheckIn,
      "currentUser": _vm.app.currentUser,
      "saveCheckIn": _vm.saveCheckIn,
      "placeNewLatLng": _vm.placeNewLatLng,
      "placeNewLatLngColumns": _vm.columns[_vm.app.nowLang].custNewLatLng,
      "setCustNewLatLngSelected": _vm.setCustNewLatLngSelected,
      "setPlaceNewLatLng": _vm.setPlaceNewLatLng,
      "custNewLatLngSelected": _vm.custNewLatLngSelected,
      "workPlaceData": _vm.workPlaceData,
      "center": _vm.center,
      "pathImage": _vm.pathImage,
      "detailDisp": _vm.detailDisp,
      "pcDisp": _vm.pcDisp,
      "scrollTop": _vm.scrollTop,
      "receivedCheckInPlaceNoLocation": _vm.receivedCheckInPlaceNoLocation,
      "flgClearFilterLocation": _vm.flgClearFilterLocation,
      "holdFilterLocation": _vm.holdFilterLocation,
      "selectedCompanyCheckin": _vm.selectedCompanyCheckin,
      "setSelectedCompanyCheckin": _vm.setSelectedCompanyCheckin
    }
  }), _vm._v(" "), _c('history-in-out', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.historyDisp),
      expression: "historyDisp"
    }],
    attrs: {
      "data": _vm.history,
      "label": _vm.labels[_vm.app.nowLang],
      "toggle": _vm.toggle,
      "setHistorySelected": _vm.setHistorySelected,
      "nowLang": _vm.app.nowLang,
      "pcDisp": _vm.pcDisp,
      "scrollTop": _vm.scrollTop
    }
  }), _vm._v(" "), _c('history-detail', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hisDetailDisp),
      expression: "hisDetailDisp"
    }],
    attrs: {
      "data": _vm.historySelected,
      "label": _vm.labels[_vm.app.nowLang],
      "toggle": _vm.toggle,
      "dropdowns": _vm.dropdowns.codreason[_vm.app.nowLang],
      "currentUser": _vm.app.currentUser,
      "saveCheckInDetail": _vm.saveCheckInDetail,
      "pathImage": _vm.pathImage,
      "pcDisp": _vm.pcDisp
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3d7e1c4a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres6oe/component.vue
// module id = 3704
// module chunks = 1